import PaginatedResponse from '../base/paginatedResponse'
import { ObjectType } from '@nestjs/graphql'
import { CategoryDto } from './model.dto'

@ObjectType()
export class CategoryPagedResultDto extends PaginatedResponse(CategoryDto) {
}
